import type { ModuleWithData} from '@zoomit/web-kit';
import { ApiManager, Modules_server } from '@zoomit/web-kit';

export const getHomePageModules = async (platform: string) => {
  return await ApiManager.get<ModuleWithData[]>(`${Modules_server}/product-home`, {
    params: {
      platform,
    },
  });
};

export const getCategoryGroupModules = async (platform: string, pageUrl: string) => {
  return await ApiManager.get(`${Modules_server}/product-category-group`, {
    params: {
      platform,
      pageUrl,
    },
  });
};

export const getProductListModules = async (
  categoryId: string,
  platform: string,
  pageUrl: string,
  brandId?: string,
) => {
  const url = brandId
    ? `${Modules_server}/product-list/${categoryId}`
    : `${Modules_server}/product-list/${categoryId}/${brandId}`;

  return await ApiManager.get<ModuleWithData[]>(url, {
    params: {
      platform,
      pageUrl,
    },
  });
};

export const getSingleProductModules = async (productId: string, pageUrl: string, platform: string) => {
  return await ApiManager.get<ModuleWithData[]>(`${Modules_server}/product/${productId}`, {
    params: {
      pageUrl,
      platform,
    },
  });
};

export const getCompareHomeModules = async (platform: string) => {
  return await ApiManager.get<ModuleWithData[]>(`${Modules_server}/compare-home`, {
    params: {
      platform,
    },
  });
};

export const getCompareListModules = async (categoryId: string, pageUrl: string, platform: string) => {
  return await ApiManager.get<ModuleWithData[]>(`${Modules_server}/compare-list/${categoryId}`, {
    params: {
      pageUrl,
      platform,
    },
  });
};

export const getProductsCompareModules = async (categorySlug: string, pageUrl: string, platform: string) => {
  return await ApiManager.get<ModuleWithData[]>(`${Modules_server}/product-compare/${categorySlug}`, {
    params: {
      pageUrl,
      platform,
    },
  });
};
